import axios from "axios";
import Vue from "vue";
import router from "@/router";
import { getHeader } from "../utils/header.js";
// 接口url前缀
const baseURL = "/jeecg-boot/";
// 预览url前缀
const pieviewURL = baseURL + "linxuan/";
// const timeout = 1000 * 10;
const service = axios.create({
  baseURL,
  // timeout,
});
service.interceptors.request.use(
  (config) => {
    let url = config.url.replace(config.baseURL, "");
    let code = config.code;
    config.headers = getHeader(url, code);
    // 文件上传（FormData）需要 multipart/form-data，必须由 axios 自动补 boundary，
    // 因此不能强制 application/json（否则后端无法解析上传的文件）
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    const code = response.status;
    if (code === 200) {
      return response.data;
    } else {
      return Promise.reject("error");
    }
  },
  (error) => {
    switch (error.response.data.code) {
      case 401:
        Vue.prototype.$message.error("登录超时");
        window.sessionStorage.clear();
        setTimeout(() => {
          window.location.reload();
          window.close();
          router.replace({
            name: "Home",
            query: { redirect: router.currentRoute.fullPath },
          });
        }, 1000);
        break;
        case 500:
        Vue.prototype.$message.error("服务器异常,请稍后");
        break;
    }
    Promise.reject(error);
  }
);
export { service, baseURL, pieviewURL };
